import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getProperties() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/global-process-properties-API", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching global process properties"
                    });
                }
            });
    }, saveProperties(data) {
        var msgType = "fetchSuccess";
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/global-process-properties-API", data).then(response => {
            return response.data;

        }).catch(error => {
            //msgType = "fetchError";
            return error.response.data;
        })
            /* .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while saving global process properties"
                    });
                }
            }) */;
    }

}